/** localStorage key for UI translation bundle (segment id, e.g. FIXTER-UK). */
export const MAIA_TRANSLATION_SEGMENT_STORAGE_KEY = 'maia.translationSegment';
